// Link parameters (UserFlows §2.1, Frontend §4.1). The source values are sent raw to `POST …/sessions`: the server
// trims, lowercases, validates and falls back to Unknown. They are never shown in the UI.

export interface LinkParams {
  /** Raw `?src=` (null when absent). */
  src: string | null
  /** Raw `?utm_source=`; the server uses it only when `src` is null. */
  utmSource: string | null
  /** `existing=1`, exactly `"1"` (links only; the embed always asks). */
  existingOnly: boolean
  /**
   * Raw `?p=`: the signed C-02 link preset (task 22, D-79; in the embed, from `data-preset`). Sent as is in #2; the
   * server verifies it (an invalid one is simply no preset). Optional for older callers.
   */
  preset?: string | null
}

export function parseLinkParams(search: string): LinkParams {
  const query = new URLSearchParams(search)
  return {
    src: query.get('src'),
    utmSource: query.get('utm_source'),
    existingOnly: query.get('existing') === '1',
    preset: query.get('p'),
  }
}
